import type { HTMLAttributes, ReactNode } from "react";

export type BadgeTone = "accent" | "neutral" | "success" | "warning" | "danger";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  tone?: BadgeTone;
}

export function Badge({
  children,
  className,
  tone = "neutral",
  ...props
}: BadgeProps) {
  const classes = ["marker-badge", `marker-badge--${tone}`];
  if (className) {
    classes.push(className);
  }

  return (
    <span className={classes.join(" ")} {...props}>
      {children}
    </span>
  );
}
